export default "__VITE_ASSET__BjmMHkst__"